import React from 'react'
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/logo.png';

function ExamNavbar() {
  let navigate = useNavigate();
  return (
   
        <nav className="navbar navbar-expand-md navbar-light sticky-top bg-light">
                <div className="container-fluid px-5">
                    <img src={logo} alt="Logo" width="140px" height="60px" className="navbar-brand d-inline-block align-top" data-loaded="true" />
                    {/* <div className="navbar-nav">
                      <a className="nav-item certificate-btn" onClick={()=>{ navigate('/certificate-verify')}}>Verify Certificate</a>
                   </div> */}
                </div>
        </nav>
    
  )
}

export default ExamNavbar